import React from "react";

function TestMicOff() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className="mt-0.5 mr-3"
    >
      <g clipPath="url(#clip0_209_115)">
        <path
          stroke="#747B84"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
          d="M.667.667l14.666 14.666M10 6.227v-3.56a2 2 0 00-3.96-.4m5.293 9.033a4.666 4.666 0 01-8-3.3V6.667m9.334 0V8c0 .275-.025.55-.074.82M8 12.667v2.666m-2.667 0h5.334M6 6v2a2 2 0 003.413 1.413L6 6z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_209_115">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default TestMicOff;
